import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import withStyles from '@cred/react-theme'

class FormField extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    status: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    small: PropTypes.bool,
    signRightPosition: PropTypes.bool,
    icon: PropTypes.bool,
    label: PropTypes.string
  }

  static defaultProps = {
    children: [],
    status: {},
    value: '',
    className: '',
    small: false,
    signRightPosition: false,
    icon: true,
    label: ''
  }

  static displayName = 'FormField'

  state = {hasFocus: false}

  handleFocus = () => {
    this.setState({hasFocus: true})
  }

  handleBlur = () => {
    this.setState({hasFocus: false})
  }

  render() {
    const {
        className,
        children,
        value,
        status,
        small,
        signRightPosition,
        icon,
        disabledField,
        label,
        styles
      } = this.props,
      showError = status.touched && status.error,
      floatLabel = value.toString().length > 0,
      iconClass = icon ? styles.withIcon : '',
      disabledFieldClass = disabledField ? styles.disabledField : '',
      cls = [
        className,
        showError ? styles.error : '',
        showError ? 'error' : '',
        floatLabel && !small ? styles.floatLabel : '',
        floatLabel && !small ? 'float-label' : '',
        styles.field,
        iconClass,
        !label ? styles.noLabel : '',
        disabledFieldClass
      ]

    let iconClassName = ''

    if (disabledField) {
      iconClassName = 'icon-lock-hole'
    } else if (showError) {
      iconClassName = 'icon-warning'
    } else if (!status.error && !status.active && floatLabel) {
      iconClassName = 'icon-check'
    }

    return (
      <div
        className={cls.join(' ')}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
      >
        {children}
        {icon ?
          <i
            className={[
              styles.fieldIcon,
              small ? styles.smallField : '',
              signRightPosition ? styles.signRight : '',
              'cred-icon',
              iconClassName
            ].join(' ')}
          />
          :
          ''
        }
        {showError ?
          <Font type="bodySmall" color="error" className="mt-8">
            {status.error}
          </Font>
          :
          ''
        }
      </div>
    )
  }
}

export {FormField as FormFieldNoHoc}

export default withStyles(
  defaultStyles, {
    fox1,
    thebalance1,
    investopedia1,
    forbes1,
    credible3
  }
)(FormField)
